import { cardsData } from '@/mocks/home';

export default function CardsSection() {
  const handleScroll = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="cards" className="w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
            精选专题
          </h2>
          <p className="text-sm text-foreground-500">深度整理最热门黑料吃瓜内容</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cardsData.map((card) => (
            <button
              key={card.id}
              onClick={() => handleScroll('#carousel')}
              className="group flex flex-col bg-background-50 rounded-2xl overflow-hidden border border-secondary-200/40 hover:border-primary-200 transition-all duration-200 cursor-pointer text-left"
            >
              <div className="relative aspect-[3/2] overflow-hidden">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    const target = e.currentTarget;
                    const parent = target.parentElement;
                    target.style.display = 'none';
                    if (parent) {
                      parent.style.display = 'none';
                    }
                  }}
                />
                <span className="absolute top-3 left-3 px-3 py-1 rounded-full bg-primary-500/90 text-background-50 text-xs font-medium whitespace-nowrap">
                  {card.badge}
                </span>
              </div>
              <div className="p-5 flex flex-col flex-1">
                <h3 className="font-heading text-base md:text-lg text-foreground-800 mb-2 group-hover:text-primary-600 transition-colors">
                  {card.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed flex-1">
                  {card.desc}
                </p>
                <div className="flex items-center gap-1 mt-4 text-xs text-primary-500 font-medium">
                  <span>阅读全文</span>
                  <i className="ri-arrow-right-line"></i>
                </div>
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}